module.exports = __webpack_public_path__ + "img/jsj autograph - peter.cfb0c169.jpg";